import React from "react";
import {Nav, Tab, Card } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import SwitchLogo from '../../Assets/Switch_ES_Logo.png'
import NatsumeChibi from '../../Assets/Image/(Jewel_Ruby)_Natsume_Sakasaki_Chibi.webp'
import NatsumeSound from '../../Assets/Sound/vo_natsume_bm_skill_3.mp3'
import ClickMeAnimation from "../Fun/ChibiButton";
import NatsumeHead from '../../Assets/Image/natsume_head.png'
import Table from 'react-bootstrap/Table';

import {
    AiFillGithub,
    AiOutlineTwitter
  } from "react-icons/ai";

 import { BsMusicNoteBeamed } from "react-icons/bs";

function ContactsCard() {
  return (
    <Card className="box-card">
    <Tab.Container  id="contacts-page" defaultActiveKey="Contact">
          <Nav variant="pills" fill className="navi-custom">
            <Nav.Item>
              <Nav.Link eventKey="Contact">Contact</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="GameIDs">Game IDs</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Extra">Credits</Nav.Link>
            </Nav.Item>
          </Nav>
    <Tab.Content>
            <Tab.Pane eventKey="Contact">
      <Card.Body>
        <Row className="contacts buttonBox" style={{textAlign: "center"}}>
        <Col md={6}>
          <div className="buttonWrapper">
                <a
                href="https://twitter.com/sakasakitty"
                target="_blank" 
                rel="noopener noreferrer"
                title="Twitter"
                className="btn customLink"
              >
                Main Twt <AiOutlineTwitter style={{fontSize: "25px", marginLeft: "5px"}}/>
              </a>
              </div>
              </Col>
              <Col md={6}>
              <div className="buttonWrapper">
                <a
                href="https://twitter.com/gradualcolors"
                target="_blank" 
                rel="noopener noreferrer"
                title="Twitter"
                className="btn customLink"
              >
                Projects Twt <AiOutlineTwitter style={{fontSize: "25px", marginLeft: "5px"}}/>
              </a>
              </div>
              </Col>
              </Row>
              <Row className="contacts buttonBox" style={{textAlign: "center"}}>
              <Col md={6}>
              <div className="buttonWrapper">
             <a
                href="https://github.com/gradualcolors"
                target="_blank" 
                rel="noopener noreferrer"
                title="Github"
                className="btn customLink"
              >
                Github <AiFillGithub style={{fontSize: "25px", marginLeft: "5px"}}/>
              </a>
              </div>
              </Col>
              <Col md={6}>
              <div className="buttonWrapper">
             <a
                href="https://stars.ensemble.moe/@natsume"
                target="_blank" 
                rel="noopener noreferrer"
                title="Github"
                className="btn customLink"
              >
                MakoTools <BsMusicNoteBeamed style={{fontSize: "25px", marginLeft: "5px"}}/>
              </a>
              </div>
        </Col>
        </Row>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>

    <Tab.Content>
    <Tab.Pane eventKey="GameIDs">
      <Card.Body>
      <div className="contacts">
      <Table>
      <tbody>
        <tr>
          <td>
            <p><strong>Genshin Impact: </strong></p>
            <ul className="bulletsCustom">
            <li>IGN: rai</li>
            <li>UUID: 615997430</li>
            </ul>
          </td>
          <td>
          <p><strong>Fire Emblem Heroes: </strong></p>
          <ul className="bulletsCustom">
            <li>User ID: Aine</li>
            <li>Friend Code: 2592893777</li>
          </ul>
          </td>
        </tr>
        <tr>
          <td>
          <p><strong>Nintendo Switch: </strong></p>
          <ul className="bulletsCustom">
            <li>User ID: ▽natsume△</li>
            <li>Friend Code: SW-5036-1617-7317</li>
          </ul>
          </td>
          <td>
          <p><strong>Ensemble Stars: </strong></p>
          <ul className="bulletsCustom">
            <li>I am on JP & EN Music as well Basic.</li>
            <li>Friend Code: Please message me for it!</li>
          </ul>
          </td>
        </tr>
      </tbody>
      </Table>


        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    <Tab.Content>
    <Tab.Pane eventKey="Extra">
      <Card.Body>

      <h4>Credits</h4>
    <p>Live2D Animations and Models used for this theme are Happy Elements / Ensemble Stars' property. This also uses some assets from Ensemble Stars Basic. I, in no way, own these assets. The svg files used for the preloading screen is credited to @lore_likes_cats!</p>
    <p>As for the code...</p>
    <p>Permission is hereby granted, free of charge, to any person obtaining
      a copy of this software and associated documentation files (the
      "Software"), to deal in the Software without restriction, including
      without limitation the rights to use, copy, modify, merge, publish,
      distribute, sublicense, and/or sell copies of the Software, and to
      permit persons to whom the Software is furnished to do so, subject to
      the following conditions:</p>
      <p>
      The above copyright notice and this permission notice shall be
      included in all copies or substantial portions of the Software.</p>
      <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
      LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
      OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
      WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    </Tab.Container>
    <div className="profileFooter">
        <Row>
        <Col md={4}>
        <img className="logo" src={SwitchLogo}/>
        </Col>
        <Col md={8}>
        <ClickMeAnimation head={NatsumeHead} img={NatsumeChibi} sound={NatsumeSound}/>
        </Col>
        </Row>
    </div>
    </Card>
  );
}

export default ContactsCard;

